export const DEFAULT_DATE_FORMAT = 'd MMM yyyy';
export const APPLICATION_DATE_FORMAT = 'MM/dd/yyyy';

export const DATE_FORMAT_INLINE = 'MMM d, yyyy';
export const DATETIME_FORMAT_INLINE = 'yyyy-MM-dd h:mm a';
export const QUOTE_DATE_FORMAT = 'dd MMM yyyy h:mm a';
